import React from 'react';
import styles from './vtrg_inner_block.scss';

const VtrgInnerBlock = () => (
    <div>
        <h1>VtrgInnerBlock component</h1>
    </div>
);

export default VtrgInnerBlock;